import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import bdService from "../../../services/bodega.service";
import bdMaestro from "../../../services/maestros.service";
import { useSnackbar } from "notistack"; //Para alertas notificaciones

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";

//* Helper de confirmacion dialog
import ConfirmationDialog from "../../../helpers/ConfirmationDialog";
import TextFieldCustom from "../../../helpers/CustomTextFields";
import NumFormato from "../../../helpers/numerico";

const Inventario = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [sucursales, setSucursales] = useState([]);
  const [SucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [bSeleccionada, setbSeleccionada] = useState(false);
  const [NomBodega, setNomBodega] = useState(null);
  const [BodegaSeleccionada, setBodegaSeleccionada] = useState("");
  const [isBloqueo, setIsBloqueo] = useState(false);
  //**************************************** */
  /* confirmacion */
  //**************************************** */
  const [openDialogConfirmacion_return, setOpenDialogConfirmacion_return] =
    useState(false);
  const [openDialogConfirmacion_reload, setOpenDialogConfirmacion_reload] =
    useState(false);
  //**************************************** */
  //*   Suma de Stock */
  //**************************************** */
  const [CodigoDig, setCodigoDig] = useState("");
  const [Cantidad, setCantidad] = useState(0);
  //**************************************** */
  /**** Producto  */
  const [LecturaCodigoFormato, setLecturaCodigoFormato] = useState("");
  const [LecturaCodBarra, setLecturaCodBarra] = useState("");
  const [LecturaNombre, setLecturaNombre] = useState("");
  const [LecturaUnidad, setLecturaUnidad] = useState("");
  const [LecturaStk, setLecturaStk] = useState(0);
  const [LecturaNv, setLecturaNv] = useState(0);
  const [LecturaCntGrabada, setLecturaCntGrabada] = useState(0);
  //*************************************** */
  const ScanBarraRef = useRef(null);
  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const CargarBodegas = async () => {
    try {
      const datos = await bdMaestro.Bodegas(-1, "T");
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
      } else if (datos.status === 400) {
        // Esta mal
        // console.log(datos);
      }
    } catch (error) {
      // Manejo del error si ocurre
      console.log(error);
    }
  };

  useEffect(() => {
    CargarBodegas();
  }, []);

  const BuscarCodigo = async (CodigoBarra) => {
    if (CodigoBarra.length > 0) {
      try {
        // ********************************************************** */
        //  Extrallendo datos para exportar a pdf
        // ********************************************************** */
        const response = await bdService.Inventario(
          SucursalSeleccionada,
          BodegaSeleccionada,
          "*",
          CodigoBarra
        );
        // alert(response.status);
        if (response.status === 200) {
          // ********************************************************** */
          //* Generar Reporte
          // ********************************************************** */
          const producto = response.data.inventario[0];
          if (CodigoDig === producto.CodigoFormato) {
            //******  Producto suma + 1  */´
            //convierto a numero
            const numCant = NumFormato.ConvertirNumero(Cantidad.toString());
            var CntActual = numCant + 1;
            //convierto a string
            CntActual = NumFormato.ConvertirNumeroParaFormatear(CntActual);
            //Formateo
            setCantidad(NumFormato.NumeroFormateado(CntActual, false, true, 2));
          } else {
            //******  Producto nuevo o cambio de producto o mal seleccionado  */
            if (CodigoDig === "") {
              //Si el producto es nuevo dejar en 1 y stand by para nueva digitacion ..
              // habilitar boton Cambiar Cantidad/Terminar
              // setCodBarra(""); //limpiar para una nueva digitacion
              setCodigoDig(producto.CodigoFormato);
              //************* Producto **********/
              setLecturaCodigoFormato(producto.CodigoFormato);
              setLecturaCodBarra(producto.CodigoBarra);
              setLecturaNombre(producto.Nombre);
              setLecturaUnidad(producto.Unidad);
              setLecturaStk(
                NumFormato.NumeroFormateado(
                  producto.StockActual.toString(),
                  false,
                  true,
                  2
                )
              );
              setLecturaCntGrabada(
                NumFormato.NumeroFormateado(
                  producto.Cantidad.toString(),
                  false,
                  true,
                  2
                )
              );
              setLecturaNv(
                NumFormato.NumeroFormateado(
                  producto.NotaVenta.toString(),
                  false,
                  true,
                  2
                )
              );
              //*********************************/
              //******  Producto suma + 1  */´
              //convierto a numero
              const numCant = NumFormato.ConvertirNumero(Cantidad.toString());
              var Cnt_Actual = numCant + 1;
              //convierto a string
              Cnt_Actual = NumFormato.ConvertirNumeroParaFormatear(
                producto.Cantidad + Cnt_Actual
              );
              //Formateo
              setCantidad(
                NumFormato.NumeroFormateado(Cnt_Actual, false, true, 2)
              );

              //*********************************/
            } else {
              // Si producto cambio o mal scaneado preguntar
              // Si desea pasar a otro producto Si o si se equivoco no dejar como esta
              enqueueSnackbar(
                `¡¡ Este producto es distinto al que está contando !!`,
                {
                  variant: "info",
                  anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                  },
                }
              );
              // setCodBarra("");
            }
          }
          // ********************************************************** */
        } else if (response.status === 400) {
          enqueueSnackbar(`¡¡ No existe este código de barra !!`, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          // setCodBarra("");
        } else {
          // ********************************************************** */
          // Restaurar el valor original
          // ********************************************************** */
          //Error para que aparezca
          // ********************************************************** */
          enqueueSnackbar(
            `Error no se pudo obtener datos de la base de datos ${response.data.msg}`,
            {
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            }
          );
          // ********************************************************** */
        }
      } catch (error) {
        enqueueSnackbar(`Error: ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    }
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const handleChangeComboBox = async (event) => {
    const nombreSeleccionado = event.target.value;
    const SucBodSelect = sucursales.find(
      (sucursal) => sucursal.Nombre === nombreSeleccionado
    );
    setSucursalSeleccionada(SucBodSelect.Sucursal);
    setBodegaSeleccionada(SucBodSelect.Bodega);
    setNomBodega(nombreSeleccionado);
    setIsBloqueo(true);
    setbSeleccionada(true);
  };
  //*********************************************************** */
  //**************** Consultando al CodigoBarra */
  //*********************************************************** */
  const handleKeyDownCodBarra = (event) => {
    if (event.key === "Enter") {
      const CodigoBarra = event.target.value;
      BuscarCodigo(CodigoBarra);
      event.target.value = "";
      setTimeout(() => {
        ScanBarraRef.current.focus();
      }, 500);
    }
  };

  //*********************************************************** */
  // Cantidad
  //*********************************************************** */

  const handleCantidadChange = (value) => {
    setCantidad(value);
  };

  const handleCantidadonBlur = (value) => {
    setCantidad(value.target.value);
  };

  const handleCantidadFocus = (value) => {
    setCantidad(value.target.value);
  };
  //*********************************************************** */
  // useEffect(() => {
  //   if (isBloqueo && isFocusScan === false) {
  //     ScanBarraRef.current.focus();
  //   }
  // }, [isBloqueo, isFocusScan]);

  //*********************************************************** */
  // Botones avatar
  //*********************************************************** */
  const onClickActualizar = async () => {
    try {
      //******  Producto suma + 1  */´
      //convierto a numero
      //*********************************************************** */
      const numCant = NumFormato.ConvertirNumero(Cantidad.toString());
      //*********************************************************** */
      const response = await bdService.Put_Inventario(
        SucursalSeleccionada,
        BodegaSeleccionada,
        LecturaCodigoFormato.replace("-", ""),
        LecturaCodBarra,
        numCant
      );
      //*********************************************************** */
      if (response.status === 200) {
        enqueueSnackbar(`¡¡¡Registro actualizado!!!`, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        //*** Reinicia para otro código */
        onClickReload();
        //***
      } else {
        enqueueSnackbar(`Error en grabación ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
      console.log("Error ", error);
    }
  };

  const onClickPrincipio = () => {
    // Limpiando variables
    setLecturaCodigoFormato("");
    setLecturaCodBarra("");
    setLecturaNombre("");
    setLecturaUnidad("");
    setLecturaStk("");
    setLecturaNv(0);
    setLecturaCntGrabada(0);
    setSucursales([]);
    setSucursalSeleccionada(null);
    setbSeleccionada(false);
    setNomBodega(null);
    setBodegaSeleccionada("");
    setIsBloqueo(false);
    setCodigoDig("");
    setCantidad(0);
    CargarBodegas();
  };

  const onClickReload = () => {
    // Limpiando variables
    setLecturaCodigoFormato("");
    setLecturaCodBarra("");
    setLecturaNombre("");
    setLecturaUnidad("");
    setLecturaStk("");
    setLecturaNv(0);
    setLecturaCntGrabada(0);
    setbSeleccionada(true);
    setIsBloqueo(true);
    setCodigoDig("");
    setCantidad(0);
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 200);
  };
  //*********************************************************** */
  //*                        Dialgos
  //*********************************************************** */
  //******   Dialog Return  */
  const handleOpenDialogConfirmacion_return = () => {
    setOpenDialogConfirmacion_return(true);
  };
  const handleCloseDialogConfirmacion_return = () => {
    setOpenDialogConfirmacion_return(false);
  };
  const handleNoConfirmacion_return = () => {
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 500);
  };
  const handleSiConfirmacion_return = () => {
    onClickPrincipio();
  };
  //******   Dialog Reload  */
  const handleOpenDialogConfirmacion_reload = () => {
    setOpenDialogConfirmacion_reload(true);
  };
  const handleCloseDialogConfirmacion_reload = () => {
    setOpenDialogConfirmacion_reload(false);
  };
  const handleNoConfirmacion_reload = () => {
    setTimeout(() => {
      ScanBarraRef.current.focus();
    }, 500);
  };
  const handleSiConfirmacion_reload = () => {
    onClickReload();
  };
  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="sm">
        <Container maxWidth="sm" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF", height: "auto" }}
            >
              {bSeleccionada === false && (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Inventario
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Select
                      value={BodegaSeleccionada} // we want to work in controlled mode
                      displayEmpty
                      fullWidth
                      onChange={handleChangeComboBox} // we want to work in controlled mode
                    >
                      <MenuItem value="" disabled>
                        Sucursales
                      </MenuItem>
                      {sucursales?.map((option) => {
                        return (
                          <MenuItem key={option.Nombre} value={option.Nombre}>
                            {option.Nombre ?? option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                </Grid>
              )}
            </Box>
            {isBloqueo ? (
              <Grid item xs={12} sm={12} sx={{ p: 1 }}>
                <Box
                  component="form"
                  borderRadius="8px"
                  sx={{
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{
                      color: "text.secondary",
                      textAlign: "center",
                    }}
                  >
                    {bSeleccionada && (
                      <Box
                        sx={{ color: "text.secondary", textAlign: "center" }}
                      >
                        Inventario {NomBodega}
                      </Box>
                    )}
                  </Grid>
                </Box>
              </Grid>
            ) : null}
            {CodigoDig.length > 0 ? (
              <Grid container spacing={1} sx={{ p: 1 }}>
                <Grid item xs={12}>
                  <Item>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        sx={{
                          color: "text.secondary",
                          textAlign: "center",
                        }}
                      >
                        <TextFieldCustom
                          fullWidth
                          disabled
                          label={`Stk.Act.`}
                          value={LecturaStk}
                          onKeyDown={handleKeyDownCodBarra}
                          labelStyle={{
                            color: "blue",
                            fontSize: "15px",
                            textAlign: "center",
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        sx={{
                          color: "text.secondary",
                          textAlign: "center",
                        }}
                      >
                        <TextFieldCustom
                          fullWidth
                          disabled
                          label={`NV`}
                          value={LecturaNv}
                          labelStyle={{
                            color: "red",
                            fontSize: "15px",
                            textAlign: "center",
                          }}
                          onKeyDown={handleKeyDownCodBarra}
                        />
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>
                <Grid item xs={12}>
                  <TextFieldCustom
                    TamanioFuente="24px"
                    alineacion="right"
                    value={Cantidad}
                    isNumeric={true}
                    decimal={true}
                    decimalCantidad={2}
                    maxLength={12}
                    label={`Cant(${LecturaCntGrabada}) ( ${LecturaUnidad} )`}
                    inputMode="numeric" //muestra el tablero de numero en celular // numeric / text
                    onChange={handleCantidadChange}
                    onFocus={handleCantidadFocus}
                    onBlur={handleCantidadonBlur}
                  />
                </Grid>
              </Grid>
            ) : null}
            {isBloqueo ? (
              <Grid sx={{ p: 1 }}>
                <Grid item xs={12}>
                  <Item>
                    <Grid container spacing={0}>
                      <Grid
                        item
                        xs={CodigoDig.length > 0 ? 4 : 8}
                        sm={CodigoDig.length > 0 ? 4 : 8}
                        sx={{
                          color: "text.secondary",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          fullWidth
                          inputRef={ScanBarraRef}
                          label="Scan Cód.Barra"
                          color="success"
                          onKeyDown={handleKeyDownCodBarra}
                          inputProps={{
                            inputMode: "numeric",
                            maxLength: 15,
                          }}
                        />
                      </Grid>
                      {CodigoDig.length > 0 ? (
                        <Grid item xs={8}>
                          <IconButton onClick={onClickActualizar}>
                            <Avatar sx={{ backgroundColor: "green" }}>
                              <CheckCircleRoundedIcon />
                            </Avatar>
                          </IconButton>
                          <IconButton
                            onClick={handleOpenDialogConfirmacion_reload}
                          >
                            <Avatar sx={{ backgroundColor: "purple" }}>
                              <ReplayRoundedIcon />
                            </Avatar>
                          </IconButton>
                          <ConfirmationDialog
                            open={openDialogConfirmacion_reload}
                            onClose={handleCloseDialogConfirmacion_reload}
                            title="¿Desea escanear o escribir otro código de barra?"
                            onConfirm={handleSiConfirmacion_reload}
                            onCancel={handleNoConfirmacion_reload}
                          />
                          <IconButton
                            onClick={handleOpenDialogConfirmacion_return}
                          >
                            <Avatar sx={{ backgroundColor: "red" }}>
                              <CancelRoundedIcon />
                            </Avatar>
                          </IconButton>
                          <ConfirmationDialog
                            open={openDialogConfirmacion_return}
                            onClose={handleCloseDialogConfirmacion_return}
                            title="¿Está seguro de salir del inventario?, ¡¡volverá al inicio!!"
                            onConfirm={handleSiConfirmacion_return}
                            onCancel={handleNoConfirmacion_return}
                          />
                        </Grid>
                      ) : null}
                      {isBloqueo && CodigoDig.length === 0 ? (
                        <Grid item xs={4}>
                          <IconButton
                            onClick={handleOpenDialogConfirmacion_return}
                          >
                            <Avatar sx={{ backgroundColor: "red" }}>
                              <CancelRoundedIcon />
                            </Avatar>
                          </IconButton>
                          <ConfirmationDialog
                            open={openDialogConfirmacion_return}
                            onClose={handleCloseDialogConfirmacion_return}
                            title="¿Está seguro de salir del inventario?, ¡¡volverá al inicio!!"
                            onConfirm={handleSiConfirmacion_return}
                            onCancel={handleNoConfirmacion_return}
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            ) : null}
            {CodigoDig.length > 0 ? (
              <Grid container spacing={1} sx={{ p: 1 }}>
                <Grid item xs={12}>
                  <Box
                    borderRadius={"8px"}
                    sx={{
                      boxShadow: 1,
                      backgroundColor: "#FFFFFF",
                      color: "text.secondary",
                      p: 0,
                      maxWidth: "100%",
                      textAlign: "center",
                    }}
                  >
                    <TextFieldCustom
                      disabled
                      id="full"
                      label={`Producto ${LecturaCodigoFormato}`}
                      value={LecturaNombre}
                      TamanioFuente={"13px"}
                      Alineacion={"left"}
                      labelStyle={{
                        color: "blue",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      multiline
                      fullWidth
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    borderRadius={"8px"}
                    sx={{
                      boxShadow: 1,
                      backgroundColor: "#FFFFFF",
                      color: "text.secondary",
                      p: 0,
                      maxWidth: "100%",
                      textAlign: "center",
                    }}
                  >
                    <TextFieldCustom
                      disabled
                      id="full"
                      label="Barra"
                      value={LecturaCodBarra}
                      TamanioFuente={"13px"}
                      Alineacion={"Center"}
                      labelStyle={{
                        color: "blue",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      fullWidth
                    />
                  </Box>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default Inventario;
